<template>
    <div>
        <!-- <v-search v-if="show">
            <router-link :to="{path:'add'}">
                <a-button v-if="this.$route.path=='/mingdan/list'" type="primary" class="fr opbuttonmt">新增</a-button>
            </router-link>条件筛选
        </v-search>-->
        <a-card title="系统列表">
            <a-button slot="extra" type="primary" @click="showModal">新增系统</a-button>
            <a-modal
                :visible="visible"
                title="添加系统"
                @cancel="closeModal"
                @ok="handleSubmit"
                :confirmLoading="false"
            >
                <a-form @submit="handleSubmit" layout="inline" :form="form">
                    <a-form-item label="系统名称">
                        <a-input
                            style="width:300px"
                            v-decorator="[
                                    'systemname',
                                    {
                                        initialValue: undefined,
                                        rules: [{ required: true, message: '请输入系统名称' }]
                                    }
                                ]"
                            placeholder="请输入系统名称"
                        />
                    </a-form-item>
                </a-form>
            </a-modal>
            <v-tablelist></v-tablelist>
        </a-card>

    </div>
</template>

<script>
import TableList from "./tablelist.vue";
// import Search from "./search.vue";

export default {
    data() {
        return {
            // show: true
            form: this.$form.createForm(this),
            visible: false,
            // loading: false
        };
    },
    methods: {
        showModal() {
            this.visible = true;
        },
        closeModal() {
            this.visible = false;
        },
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (err) return;
                // this.loading = true;
                // this.D.add({
                //     type: "rc_io/sysadd",
                //     params: values
                // }).then(() => {
                //     this.$router.push({
                //         path: "list",
                //         query: {
                //             _t: new Date().getTime()
                //         }
                //     });
                // });

                this.$store.dispatch({
                    type: "rc_io/sysadd",
                    params: values
                }).then((res) => {
                    this.closeModal(res);
                });
            });
        }
    },
    computed: {},
    components: {
        "v-tablelist": TableList
        // "v-search": Search
    },
    beforeMount() {
        // if (this.$route.path.indexOf("/zhixing") > -1) {
        //     this.show = false;
        // }
    },
    mounted() {}
};
</script>

<style scoped>
</style>
